// extracted by mini-css-extract-plugin
export var indeterminate = "_4s-5";
export var md = "_4s-4";
export var semantic = "_4s-6";
export var sm = "_4s-3";
export var text = "_4s-7";
export var toggleInput = "_4s-0";
export var toggleSwitch = "_4s-1";
export var xs = "_4s-2";